import { lazy } from 'react';

// project-imports
import DashboardLayout from 'layout/Dashboard';
import Loadable from 'components/Loadable';
import { Navigate } from 'react-router-dom';
import AuthGuard from '../layout/Auth/AuthGuard';

// render - basic component pages
const Enquiries = Loadable(lazy(() => import('../sections/enquiries/Enquiries')));

// ==============================|| COMPONENT ROUTING ||============================== //

const EnquiriesRoutes = {
  path: '/',
  element: <AuthGuard allowedRoles={['SUPER_ADMIN']}/>,
  children: [
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        {
          path: 'enquiries',
          children: [
            {
              // This makes /menu automatically open /menu/categories
              index: true, 
              element: <Navigate to="/enquiries" replace /> 
            },
            {
              path: 'view-enquiries',
              element: <Enquiries />
            }
          ]
        }
      ]
    }
  ]
};

export default EnquiriesRoutes;
